import { useState, useEffect } from 'react';
import { persianLanguage } from '../../../constants/persianTerms';

export function ErrorBoundary({ children }) {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const handleError = (event) => {
      event.preventDefault();
      setHasError(true);
      // console.error('Error caught:', event.error);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleError);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleError);
    };
  }, []);

  if (hasError) {
    return (
      <div className="text-center p-5">
        <h4 className="text-red-500">
            {persianLanguage.phrase.error.ERROR_400}
        </h4>
        <button 
          className="mt-3 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          onClick={() => window.location.reload()}
        >
          {persianLanguage.word.general.REFRESH}
        </button>
      </div>
    );
  }

  return children;
}